/**
 * The reload copy for a Server Action the current deployment no longer has.
 *
 * Kept apart from `stale-deployment.ts` on purpose: that module imports
 * `unstable_isUnrecognizedActionError` from `next/navigation`, which the
 * server build of `next/navigation` does not export, so any server module
 * (a "use server" action, an App Route) that imports it fails `next build`.
 * Server code that only needs the words imports them from here.
 */
export const STALE_PAGE_MESSAGE =
  "We updated the app while this page was open, so that didn't go through. Reload the page and try again.";
